import React, {useLayoutEffect} from 'react'
import {Tilt} from "react-tilt";
import { motion , useInView } from "framer-motion";
import {fadeIn} from '../Components/Utilities/motion'
import Color from '../Components/Colors/Color'
import "../Styles/Service.css"
import { useNavigate } from 'react-router-dom'

const Service = () => {

  const navigate = useNavigate();

  useLayoutEffect(() => {
  
    window.scrollTo(0, 0);
  
  }, [])

  const handleMoveToServicePage = () => {
    navigate('/services');
  }

  return (
    <div className='service-container' style={{color: Color.secondaryText}}>
      <h1 className='service-header' style={{color: Color.secondaryText}}>Our Services</h1>
      <div className='service-section-content-container'>

      <div className='service-image-container-medium'>
          <img src='/Images/service-img-2.jpg' alt='service-image' className='service-image-medium' />
      </div>

      <div className='service-image-text-container row'>
        <div className='service-image-container col-lg-6 col-md-12'>
          <img src='/Images/service-img-2.jpg' alt='service-image' className='service-image' />
        </div>
        <div className='service-text-container col-lg-6 col-md-12'>
          {/* <div className='service-hl-container'></div> */}
            <ul className='service-content-list'>
            <div className='service-hl-container'></div>
              <li className='service-content-item'>
                <h4 className='service-content-header'>Sales & After Sales</h4>
                <p className='service-content-text'>Experience unparalleled sales and after-sales, your trusted provider of top-quality printing consumables and cutting-edge printers.</p>
              </li>
              <li className='service-content-item'>
                <h4 className='service-content-header'>Maintenance</h4>
                <p className='service-content-text'>Count on our dedicated team of experts for comprehensive maintenance solutions that keep your printing equipment running smoothly, maximizing productivity and minimizing downtime.</p>
                
              </li>
              <li className='service-content-item'>
              <h4 className='service-content-header'>Repairment</h4>
                <p className='service-content-text'>Swift and reliable printer repairs by our expert technicians ensure minimal downtime, keeping your printing equipment running smoothly.</p>
              </li>
              <div className='service-hl-container'></div>

              <button className='service-explore-btn' style={{backgroundColor: Color.secondaryText, color: Color.thirdText}} onClick={handleMoveToServicePage}>
                Explore
              </button>

            </ul>

            <button className='service-explore-btn medium' style={{backgroundColor: Color.secondaryText, color: Color.thirdText}} onClick={handleMoveToServicePage}>
                Explore
              </button>
            
        </div>
      </div>
      </div>
    </div>
  )
}

export default Service;